import request from '@/utils/request.js'
import { V3, EMERGENCY_RESOLVED } from '@/utils/config.js'

export function getEmergencies(params) {
    return request({
        url: '/'+ V3 +'/emergencies',
        method: 'get',
        params,
    })
}

export function getEmergency(id) {
    return request({
        url: '/'+ V3 +'/emergencies/' + id,
        method: 'get',
    })
}

export function updateEmergencyStatus(ids, status) {
    return request({
        url: '/'+ V3 +'/emergencies/status',
        method: 'patch',
        data: {
            ids,
            status
        }
    })
}

export function resolveEmergency(ids) {
    return request({
        url: '/'+ V3 +'/emergencies/status',
        method: 'patch',
        data: {
            ids,
            resolved: EMERGENCY_RESOLVED
        }
    })
}

// Settings
export function getEmergencySettings(params) {
    return request({
        url: '/'+ V3 +'/emergency-types',
        method: 'get',
        params,
    })
}

export function saveEmergencySetting(data) {
    return request({
        url: '/'+ V3 +'/emergency-types',
        method: 'post',
        data,
    })
}

export function getEmergencySetting(id) {
    return request({
        url: '/'+ V3 +'/emergency-types/' + id,
        method: 'get',
    })
}

export function updateEmergencySetting(id, data) {
    return request({
        url: '/'+ V3 +'/emergency-types/' + id,
        method: 'patch',
        data
    })
}

export function updateEmergencySettingStatus(ids, status) {
    return request({
        url: '/'+ V3 +'/emergency-types/status',
        method: 'patch',
        data: {
            ids,
            status
        }
    })
}